'use client'

import { css, cx } from '@lastbrand/web-ui-styled-system/css'
import { useEffect, useRef } from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'

import { addClassBasedOnScroll } from '../../organisms/productPageSections/productDetailsAndCare/utils'

import { ProductDetailsIconDS } from './product-details-icon-ds'

import type { ProductDetailsIconSectionDSProps } from './types'

const wrapperClass = css({
  position: 'relative',
})

const iconsContainerClass = css({
  display: 'flex',
  alignItems: 'center',
  alignContent: 'center',
  gap: 'space-12',
  alignSelf: 'stretch',
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  _after: {
    content: '""',
    position: 'absolute',
    right: 0,
    width: '66px',
    height: '48px',
    background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 30.85%)',
    pointerEvents: 'none',
  },
})

const noFadeClass = css({
  _after: {
    display: 'none',
  },
})

export const ProductDetailsIconSectionDS = ({ icons, wrapperClassName }: ProductDetailsIconSectionDSProps) => {
  const iconsContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = iconsContainerRef.current
    if (!el) return

    const handleScroll = () => {
      addClassBasedOnScroll(el, noFadeClass, 0.9)
    }

    el.addEventListener('scroll', handleScroll)

    return () => {
      el.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (icons.length === 0) return null

  return (
    <div className={cx(wrapperClass, wrapperClassName)} data-testid={TEST_LOCATORS.PRODUCT_DETAILS_ICON_SECTION}>
      <div className={iconsContainerClass} ref={iconsContainerRef}>
        {icons.map(icon => (
          <ProductDetailsIconDS key={icon.displayTitle} displayTitle={icon.displayTitle} image={icon.image} />
        ))}
      </div>
    </div>
  )
}
